import { Injectable } from '@angular/core';
import {BASE_URL, BASE_URL_API, BASE_URL_AUTH, BASE_URL_GESCOM, BASE_URL_REPORT, BASE_URL_GESCOM_V1, BASE_URL_API_MOBILE} from '../app.constants';
import {DialogService} from 'ng-metro4';
import {DomSanitizer} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import { Location } from '@angular/common';
import {TokenStorageService} from "./token-storage.service";

@Injectable({
  providedIn: 'root'
})
export class GenericsService {

  filedata: any;
  public urlImage = BASE_URL_REPORT + '/report/telechager/piece-jointe/';
  constructor(
    private http: HttpClient,
    private location: Location,
    private token: TokenStorageService,
    protected sanitizer: DomSanitizer,
    private dialogService: DialogService
  ) { }


  onBackClicked(): void {
    this.location.back();
  }

  getTenantIdFromUrl(): string | null {
    const url = window.location.hostname;
    const parts = url.split('.');
    const tenantID = parts.length >= 3 ? parts[0] : null;
    this.token.saveTenantID(tenantID);
    return tenantID;
  }
  onForwardClicked(): void {
    this.location.forward();
  }

  public getResourceAPIGescom(url): any {
    return this.http.get(`${BASE_URL_GESCOM + url}`).toPromise();
  }
  public postResourceAPIGescom(url, dto): any {
    return this.http.post(`${BASE_URL_GESCOM + url}`, dto).toPromise();
  }
  public getResourceAPI(url): any {
    return this.http.get(`${BASE_URL_API + url}`).toPromise();
  }
  public postResourceAPI(url, dto): any {
    return this.http.post(`${BASE_URL_API + url}`, dto).toPromise();
  }
  public getResource(url): any {
    return this.http.get(`${BASE_URL + url}`).toPromise();
  }
  public getResourceAPIMobile(url): any {
    return this.http.get(`${BASE_URL_API_MOBILE + url}`).toPromise();
  }
  public postResourceAPIMobile(url, dto): any {
    return this.http.post(`${BASE_URL_API_MOBILE + url}`, dto).toPromise();
  }
  public deleteResourceAPIMobile(url: string): any {
    return this.http.delete(`${BASE_URL_API_MOBILE + url}`).toPromise();
  }
  public patchResourceAPIMobile(url, dto): any {
    return this.http.patch(`${BASE_URL_API_MOBILE + url}`, dto).toPromise();
  }

  public getResourceGescomV1(url): any {
    return this.http.get(`${BASE_URL_GESCOM_V1 + url}`).toPromise();
  }

  public getResourceReport(url): any {
    return this.http.get(`${BASE_URL_REPORT + url}`).toPromise();
  }
  public getResourceAuth(url): any {
    return this.http.get(`${BASE_URL_AUTH + url}`).toPromise();
  }

  public postResource(url, dto): any {
    return this.http.post(`${BASE_URL + url}`, dto).toPromise();
  }

  public postResourceGescomV1(url, dto): any {
    return this.http.post(`${BASE_URL_GESCOM_V1 + url}`, dto).toPromise();
  }

  public postResourceAuth(url, dto): any {
    return this.http.post(`${BASE_URL_AUTH + url}`, dto).toPromise();
  }
  public postResourceReport(url, dto): any {
    return this.http.post(`${BASE_URL_REPORT + url}`, dto).toPromise();
  }

  public putResource(url, dto): any {
    return this.http.put(`${BASE_URL + url}`, dto).toPromise();
  }
  public putResourceAuth(url, dto): any {
    return this.http.put(`${BASE_URL_AUTH + url}`, dto).toPromise();
  }

  public patchResource(url, dto): any {
    return this.http.patch(`${BASE_URL + url}`, dto).toPromise();
  }

  public deleteResource(url: string): any {
    return this.http.delete(`${BASE_URL + url}`).toPromise();
  }

  public closeModalAndSendData(): any {
    /**
     * cette fonction est utilisée pour fermer la modale: elle nous permetra donc d'utiliser un seul boutton 'OK' dans une modale.
     *
     * la fonction this.dialogService.show() a 6 parametre.
     * pour utiliser un seul boutton OK dans la modale, il suffira d'ajouter à cette fonction la classe 'submit-btnS-display-ok'
     * comme 6ieme parametre
     *
     */
    let okElements;
    okElements = document.querySelectorAll('.submit-btn');
    const lastElementIndex = okElements.length - 1;
    const lastOkButton = okElements[lastElementIndex] as HTMLButtonElement; // Assertion de type
    if (lastOkButton instanceof HTMLButtonElement) {
      lastOkButton.click();
    }
  }

}
